module.exports = __webpack_public_path__ + "img/2292e230fa6ed35ca73bf24acfc1c5cb.svg";